import React, { useState } from 'react';
import './SignIn.css';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';

const SignIn = () => {
  const navigate = useNavigate();
  const { dispatch } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errorMessage) {
      setErrorMessage('');
    }
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!formData.email.trim() || !formData.password) {
      setErrorMessage('Please enter your email/username and password.');
      return;
    }

    setIsSubmitting(true);
    setErrorMessage('');

    try {
      const response = await fetch(API_URL + '/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        const data = await response.json();

        dispatch({
          type: 'SIGN_IN',
          payload: { user: data.username },
        });

        navigate('/dashboard');
      } else if (response.status === 401) {
        setErrorMessage('Invalid credentials. Please check your details and try again.');
      } else {
        setErrorMessage('Login failed. Please try again.');
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('Unable to connect to the server. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="signin_page">
      <section className="signin_shell" aria-label="Sign in">
        <div className="signin_brand">
          <div className="signin_logo_wrap">
            <img
              src="../assets/Profile.png"
              alt="Profile"
              className="profile_SignIn"
            />
          </div>
        </div>

        <div className="signin_content">
          <div className="signin_heading">
            <span className="signin_eyebrow">ACCOUNT ACCESS</span>
            <h1 className="lets_Sign_you_In">Let's sign you in</h1>
            <p className="welcome_back">
              Welcome back. Enter your details to continue.
            </p>
          </div>

          <form className="signin_form" onSubmit={handleSignIn} noValidate>
            <div className="signin_field">
              <label htmlFor="signin-email">Email, phone or username</label>
              <div className="signin_input_wrap">
                <span className="signin_input_icon" aria-hidden="true">
                  @
                </span>
                <input
                  id="signin-email"
                  type="text"
                  inputMode="email"
                  placeholder="Enter email, phone or username"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  autoComplete="username"
                  autoCapitalize="none"
                  spellCheck="false"
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <div className="signin_field">
              <label htmlFor="signin-password">Password</label>
              <div className="signin_input_wrap">
                <span className="signin_input_icon" aria-hidden="true">
                  •
                </span>
                <input
                  id="signin-password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  autoComplete="current-password"
                  disabled={isSubmitting}
                />
                <button
                  type="button"
                  className="password_toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  disabled={isSubmitting}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>

            {errorMessage && (
              <div className="signin_error" role="alert">
                <span aria-hidden="true">!</span>
                <p>{errorMessage}</p>
              </div>
            )}

            <button
              className="signIn_btn"
              type="submit"
              disabled={isSubmitting}
              aria-busy={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="signin_spinner" aria-hidden="true" />
                  Signing in...
                </>
              ) : (
                <>
                  Sign in
                  <span className="signin_arrow" aria-hidden="true">→</span>
                </>
              )}
            </button>
          </form>

          <div className="signin_footer">
            <span className="signin_footer_line" />
            <span>Secure account access</span>
            <span className="signin_footer_line" />
          </div>
        </div>
      </section>
    </main>
  );
};

export default SignIn;
